// extracted by css-extract-rspack-plugin
export default {"card":"hIXlCKz___card","content":"xA6GPJ3___content","circles":"kF2ImID___circles"};